import React from 'react'
import OneCategoryDiscountContainer from '../../../../../Components/DiscountPart/CreateDiscountContainer/OneCategoryDIscountContainer/OneCategoryDiscountContainer'
import Layout from '../../../Layout'

const OneCategoryDiscount = () => {
  return (
    <Layout>
      <OneCategoryDiscountContainer/>
    </Layout>
  )
}

export default OneCategoryDiscount